<div class="animated fadeIn">


<div class="row">

    <div class="col-lg-12">
        <div class="card">
            
            <div class="card-body" style="min-height: 600px;">
             <!-- <h4 class="box-title">Flash View </h4> -->
             <!--<a class="float-right rtbtn btn btn-primary" style="margin-top: -35px;" (click)="logout()">Logout</a>-->
              <br/>
              <div class="row form-group" >
                    <div class="col col-md-12">
                        <div class="card border border-success">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col col-md-2">
                                        <strong class="card-title">Flash View</strong>
                                    </div>
                                    <div class="col col-md-2" *ngIf="companyName==''">
                                        <select name="company" id="company" class="form-control-sm form-control" [(ngModel)]="company" (change)="chngCompId()" >
                                            <option  value="">Select Insurer</option>
                                            <option  value="">All</option>
                                            <option value="{{pdetails.companyId}}" *ngFor="let pdetails of compData">{{pdetails.companyName}}</option>
                                        </select>
                                    </div>
                                    <div class="col col-md-2">
                                        <select name="fileYear" id="fileYear" [(ngModel)]="fileYear" class="form-control-sm form-control">
                                            <option  value="">Select Year</option>
                                            <option value="{{yr}}" *ngFor="let yr of yearArr">{{yr}}</option>
                                        </select>
                                    </div>
                                    <div class="col col-md-2">
                                        <select name="selectMonth" id="selectMonth" [(ngModel)]="selectMonth" class="form-control-sm form-control">
                                            <option value="">select Month</option>
                                            <option value="January">January</option>
                                            <option value="February">February</option>
                                            <option value="March">March</option>
                                            <option value="April">April</option>
                                            <option value="May">May</option>
                                            <option value="June">June</option>
                                            <option value="July">July</option>
                                            <option value="August">August</option>
                                            <option value="September">September</option>
                                            <option value="October">October</option>
                                            <option value="November">November</option> 
                                            <option value="December">December</option> 
                                        </select>
                                    </div>
                                    <div class="col col-md-4">
                                        <button type="submit" class="btn btn-primary btn-sm" (click)="searchFile(1)" >Search</button>
                                    </div>
                                </div>

                            </div>
                            <!-- <div class="card-body" >
                                <div class="row form-group">
                                    <div class="col col-md-2" *ngIf="companyName==''">
                                        <label for="dataType" class=" form-control-label">
                                            <strong>Insurer</strong>
                                        </label>
                                    </div>
                                    <div class="col col-md-2">
                                        <label for="year" class=" form-control-label">
                                            <strong>Year</strong>
                                        </label>
                                    </div>
                                    <div class="col col-md-2">
                                        <label for="monthOrQuarter" class=" form-control-label">
                                            <strong>Month</strong>
                                        </label>
                                    </div>
                                    <div class="col col-md-4">
                                        &nbsp;
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-2" *ngIf="companyName==''">
                                        <select name="company" id="company" class="form-control-sm form-control" [(ngModel)]="company" (change)="chngCompId()" >
                                            <option  value="">All</option>
                                            <option value="{{pdetails.companyId}}" *ngFor="let pdetails of compData">{{pdetails.companyName}}</option>
                                        </select>
                                    </div>
                                    <div class="col col-md-2">
                                        <select name="fileYear" id="fileYear" [(ngModel)]="fileYear" class="form-control-sm form-control">
                                            <option  value="">Select Year</option>
                                            <option value="{{yr}}" *ngFor="let yr of yearArr">{{yr}}</option>
                                        </select>
                                    </div>
                                    <div class="col col-md-2">
                                        <select name="selectMonth" id="selectMonth" [(ngModel)]="selectMonth" class="form-control-sm form-control">
                                            <option value="">Please select</option>
                                            <option value="January">January</option>
                                            <option value="February">February</option>
                                            <option value="March">March</option>
                                            <option value="April">April</option>
                                            <option value="May">May</option>
                                            <option value="June">June</option>
                                            <option value="July">July</option>
                                            <option value="August">August</option>
                                            <option value="September">September</option>
                                            <option value="October">October</option>
                                            <option value="November">November</option> 
                                            <option value="December">December</option> 
                                        </select>
                                    </div>
                                    <div class="col col-md-4">
                                        <button type="submit" class="btn btn-primary btn-sm" (click)="searchFile(1)" >Search</button>
                                    </div>
                                </div>
                           </div> -->
                        </div>
                    </div>
                </div>
                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">
                                            <thead>
                                                <tr role="row">
                                                	 <th>Year</th>
                                                	 <th>Month</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody> 
                                            <tr role="row" class="odd" *ngFor="let fdata of fileData">
                                            	<td>{{ fdata.year }}</td>
                                            	<td>{{ fdata.month ?fdata.month:'N/A'}}</td>                                                
                                                <td>
                                                	<a  (click)="goFileDetailsPage(fdata)" class="btn" ><i class="fa fa-eye"></i></a>
                                               		<a  style="margin-left: 5px;" (click)="downloadFile(fdata)" class="btn"><i class="fa fa-download"></i></a>
                                                </td>
                                               
                                            </tr> 
                                            
                                            
                                        </tbody>
                                        </table>
            </div>
        </div>
       <div class="row">
                                    <div class="col-sm-12 col-md-5">
                                        <div class="dataTables_info" id="bootstrap-data-table_info" role="status" aria-live="polite">Showing {{(curPage-1)*perPageRow+1}} to {{(curPage-1)*perPageRow+noOfRows}} of {{totalRows}}</div>
                                    </div>
                                    <div class="col-sm-12 col-md-7">
                                        <div class="dataTables_paginate paging_simple_numbers" id="bootstrap-data-table_paginate">
                                            <ul class="pagination">
                                               <!-- <li class="paginate_button page-item previous disabled" id="bootstrap-data-table_previous" (click)="searchFile(curPage-1)" *ngIf="curPage==1">
                                                    <a  aria-controls="bootstrap-data-table" data-dt-idx="0" tabindex="0" class="page-link">Previous</a>
                                                </li>-->
                                                
                                                <li class="paginate_button page-item {{item==curPage?'active':''}}" *ngFor="let item of pages; let i = index" (click)="searchFile(item)">
                                                    <a  aria-controls="bootstrap-data-table"  class="page-link">{{item}}</a>
                                                </li>
                                                <!--<li class="paginate_button page-item next" id="bootstrap-data-table_next" (click)="searchFile(curPage-1)" >
                                                    <a  aria-controls="bootstrap-data-table" data-dt-idx="7" tabindex="0" class="page-link">Next</a>
                                                </li>-->
                                            </ul>
                                        </div>
                                    </div>
                                </div>
    </div>


</div>
</div><!-- .animated -->

